<template>
    <Dialog :scrollable="true" @close="$emit('close')">
        <v-container class="pt-0 pl-3 pr-3">
            <v-row>
                <v-col class="title-filter text-center">{{
                    $t("dialogs.filters")
                }}</v-col>
            </v-row>
            <v-row>
                <filter-home-block :title="$t('dialogs.section')">
                    <div class="SectionControl-wrapper">
                        <div>
                            <v-checkbox
                                dense
                                value="subscribed"
                                color="white"
                                class="pt-0 mt-0"
                                v-model="model.sections"
                                :label="$t('dialogs.subscribed')"
                            />
                        </div>                        
                        <div>
                            <v-checkbox
                                dense
                                value="discover"
                                color="white"
                                class="pt-0 mt-0"
                                v-model="model.sections"
                                :label="$t('dialogs.discover')"
                            />
                        </div>
                        <div>
                            <v-checkbox
                                dense
                                value="following"
                                color="white"
                                class="pt-0 mt-0"
                                v-model="model.sections"
                                :label="$t('dialogs.following')"
                            />
                        </div>
                    </div>
                </filter-home-block>
            </v-row>
             <v-row>
                <filter-home-block :title="$t('dialogs.status')">
                    <v-row>
                        <v-col class="pb-0 pt-0">
                            <v-checkbox
                                dense
                                value="true"
                                color="white"
                                class="pt-0 mt-0"
                                v-model="model.online"
                                :label="$t('dialogs.online')"
                            />
                        </v-col>
                    </v-row>
                </filter-home-block>
            </v-row>
            <v-row>
                <filter-home-block :title="$t('dialogs.age')">
                    <v-range-slider
                        dense
                        hide-details
                        min="18"
                        max="100"
                        color="white"
                        persistent-hint
                        v-model="model.range"
                        track-color="gray"
                        track-fill-color="white"
                        thumb-color="#FF5600"
                        thumb-label="always"
                        class="pt-6"
                        white-text=""
                    />
                    <v-row>
                        <v-col class="pt-0 text-start"> 18 </v-col>
                        <v-spacer />
                        <v-col class="pt-0 text-end"> 100 </v-col>
                    </v-row>
                </filter-home-block>
            </v-row>
            <v-row>
                <filter-home-block :title="$t('dialogs.sex')">
                    <v-row>
                        <v-col
                            v-for="(item, i) in genders"
                            :key="i"
                            class="pt-0"
                        >
                            <select-gender
                                :icon="item.icon"
                                :text="item.gender"
                                :active="
                                    model.activeGenders &&
                                    model.activeGenders.includes(item.icon)
                                "
                                @click="toggleGenders(item.icon)"
                            />
                        </v-col>
                    </v-row>
                </filter-home-block>
            </v-row>
            <v-row>
                <v-expansion-panels v-model="model.panel" style="border: 1px solid #ddd; border-radius: 4px;">
                    <v-expansion-panel
                        class="expanded-panels"
                        @change="changePanel"
                    >
                        <v-expansion-panel-header
                            class="expand-block-header__before-post pl-3 pt-0 pb-0"
                            expand-icon="empty-icon"
                        >
                            <v-row cols="12" align="baseline">
                                <v-col cols="1">
                                    <v-icon
                                        >mdi-chevron-{{ toggle === false ? "down" : "up" }}</v-icon
                                    >
                                </v-col>
                                <v-col cols="7">
                                    {{ $t("dialogs.tags") }}
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            fluid
                            fill-height
                            class="expand-block-body__before-post"
                        >
                            <div style="overflow-x: scroll; max-height: 300px">
                                <div
                                    v-for="group in getFilteredTagsByGender()"
                                    :key="group.title"
                                >

                                    <v-list-item
                                        v-for="tag in group.items"
                                        :key="tag.id"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title
                                                class="tags-text"
                                            >
                                                {{ tag.title }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-checkbox
                                                dense
                                                hide-details
                                                :value="tag.id"
                                                color="white"
                                                class="pt-0 mt-0"
                                                v-model="model.tags"
                                            />
                                        </v-list-item-action>
                                    </v-list-item>
                                </div>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>
            <v-row class="mt-4">
                <v-expansion-panels v-model="model.categoriesPanel" style="border: 1px solid #ddd; border-radius: 4px;">
                    <v-expansion-panel
                        class="expanded-panels"
                        @change="changeCategoriesPanel"
                    >
                        <v-expansion-panel-header
                            class="expand-block-header__before-post pl-3 pt-0 pb-0"
                            expand-icon="empty-icon">
                            <v-row cols="12" align="baseline">
                                <v-col cols="1">
                                    <v-icon
                                        >mdi-chevron-{{ categoriesToggle === false ? "down" : "up" }}</v-icon
                                    >
                                </v-col>
                                <v-col cols="7">
                                    {{ $t("pages.profile.info.categories") }}
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                            fluid
                            fill-height
                            class="expand-block-body__before-post"
                        >
                            <div style="overflow-x: scroll; max-height: 300px">                                
                                <user-categories 
                                    :is-filter-page="true"
                                    :initial-selected-filter-ids = "model.categories"
                                    @update:selectedCategoryIds="handleSelectedCategories"
                                />
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>
            <v-row class="mt-4">
                <v-expansion-panels v-model="model.countriesPanel" style="border: 1px solid #ddd; border-radius: 4px;" >
                    <v-expansion-panel class="expanded-panels" @change="changeCountriesPanel" >
                        <v-expansion-panel-header class="expand-block-header__before-post pl-3 pt-0 pb-0" expand-icon="empty-icon" >
                            <v-row cols="12" align="baseline">
                                <v-col cols="1">
                                    <v-icon>
                                        mdi-chevron-{{ countriesToggle === false ? "down" : "up" }}
                                    </v-icon>
                                </v-col>
                                <v-col cols="7">
                                    {{ $t("pages.profile.info.countries") }}
                                </v-col>
                            </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content fluid fill-height class="expand-block-body__before-post" >
                            <div style="overflow-x: scroll; max-height: 300px">
                                <v-list-item v-for="country in countries" :key="country.id" >
                                    <v-list-item-content>
                                        <v-list-item-title class="d-flex align-item-center"> 
                                            <globe class="globe-flag mr-2" v-if="country.name.toLowerCase() == 'all'"/>
                                            <img v-if="country.name.toLowerCase() !== 'all'" :src="require(`@/assets/images/flags/${country.code.toLowerCase()}.png`)" :alt="country.name" class="flags mr-2" />
                                            <span class=""> {{ country.name }}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-checkbox dense hide-details :value="country.id" color="white" class="pt-0 mt-0" 
                                            v-model="model.countries"
                                            @change="onCountryToggle(country.id, $event)"/>
                                    </v-list-item-action>
                                </v-list-item>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn
                        outlined
                        block
                        class="mt-9 pa-2"
                        @click="handleResetFilter"
                    >
                        Reset
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn
                        outlined
                        block
                        class="mt-9 pa-2"
                        @click="handleClickSave"
                    >
                        {{ $t("dialogs.save") }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <inform-dialog
            :text="dialogText"
            v-if="showErrorDialog"
            @close="showErrorDialog = false"
        />
    </Dialog>
</template>

<script>
import Dialog from "@/components/app/form/Dialog";
import FilterHomeBlock from "@/components/app/home/FilterHomeBlock";
import SelectGender from "@/components/app/home/SelectGender";
import { mapActions, mapMutations, mapState } from "vuex";
import InformDialog from "@/components/app/dialogs/InformDialog";
import UserCategories from "@/components/app/profile/UserCategories";
import Globe from "@/assets/images/icons/globe.svg?inline";

export default {
    name: "FilterHome",
    data: () => ({
        toggle: false,
        categoriesToggle: false,
        countriesToggle: false,
        showErrorDialog: false,
        model: () => {
            return {};
        },
    }),
    computed: {
        genders() {
            return [
                { gender: this.$t("dialogs.male"), icon: "male" },
                { gender: this.$t("dialogs.female"), icon: "female" },
                { gender: this.$t("dialogs.transgender"), icon: "transgender" },
            ];
        },
        dialogText() {
            return this.$t('dialogs.filter_select');
        },

        // Map the tags name to track the Mixpanel event
        selectedTagNames() {
            return this.getFilteredTagsByGender()
                .flatMap(group => group.items)
                .filter(tag => this.model.tags.includes(tag.id))
                .map(tag => tag.title);
        },
        selectedCountriesIds() {
            if (!Array.isArray(this.model.countries)) return [this.model.countries].filter(Boolean);

            const allOption = this.countries.find(c => c.name.toLowerCase() === 'all');
            if (!allOption) return this.model.countries;

            const allId = allOption.id;

            if (this.model.countries.includes(allId)) {
                return [allId];
            }
            return this.model.countries;
        },

        ...mapState({
            user_categories: (state) => state.user.user.userCategories,
            tags: (state) => {
                function groupByGroupFormatted(items) {
                    const grouped = items.reduce((accumulator, item) => {
                        if (!accumulator[item.group]) {
                            accumulator[item.group] = {
                                title: item.group,
                                items: [],
                            };
                        }

                        accumulator[item.group].items.push(item);
                        return accumulator;
                    }, {});

                    return Object.values(grouped);
                }

                return groupByGroupFormatted(state.story.tags);
            },
            filters: (state) => state.story.filters,
            currentUser: (state) => state.user.user.data,
            countries: (state) => state.story.countries,
            onlineUser: (state) =>state.detectOnline
        }),
        onlineUserIds() {
            return this.onlineUser?.onlineUsers?.map(u => u.id) || [];
        }
    },
    methods: {
        ...mapActions(["getTags", "getCountries"]),
        getFilteredTagsByGender() {
            function hasIntersection(array1, array2) {
                const set1 = new Set(array1);
                return array2.some((element) => set1.has(element));
            }

            let activeGenders = [];
            if (this.model.activeGenders) {
                if (!this.model.activeGenders.length) {
                    activeGenders = ["male", "female", "transgender"];
                } else {
                    activeGenders = this.model.activeGenders;
                }
            }

            let groups = this.tags;
            groups.map((group) => {
                group.items = group.items.filter((tag) => {
                    let allowedGenders = [];
                    if (tag.is_male === 1) {
                        allowedGenders.push("male");
                    }
                    if (tag.is_female === 1) {
                        allowedGenders.push("female");
                    }
                    if (tag.is_transgender === 1) {
                        allowedGenders.push("transgender");
                    }

                    return (
                        !this.model.activeGenders ||
                        hasIntersection(activeGenders, allowedGenders)
                    );
                });

                return group;
            });
            return groups.filter((group) => group.items.length > 0);
        },
        toggleGenders(gender) {
            if (this.model.activeGenders.includes(gender)) {
                const index = this.model.activeGenders.indexOf(gender);
                this.model.activeGenders.splice(index, 1);
            } else {
                this.model.activeGenders.push(gender);
            }
        },
        changePanel() {
            this.toggle = !this.toggle;
        },
        changeCategoriesPanel() {
            this.categoriesToggle = !this.categoriesToggle;
        },
        changeCountriesPanel() {
            this.countriesToggle = !this.countriesToggle;

            if (this.countriesToggle && (!this.countries || this.countries.length === 0)) {
                this.getCountries();
            }
        },
        handleClickSave() {
            var all_section = JSON.parse(JSON.stringify(this.model.sections));
            if(all_section.length == 0){
                this.showErrorDialog = true;
                return;
            }
            const payload = { ...this.model, countries: this.selectedCountriesIds };
            if (this.model.online) {
                payload.online_user_ids = this.onlineUserIds;
            } else {
                payload.online_user_ids = null;
            }

            this.setFilters(payload);
            localStorage.setItem("home_filters", JSON.stringify(this.model));
            this.$emit("save", payload);


            // Mixpanel tracking
            const { range: ageRange = [], categories: selectedCategoryIds = [], sections = [], activeGenders = [] } = this.model || {};
            const userCategories = this.user_categories || {};
            const selectedTagNames = this.selectedTagNames || [];
            const selectedCountriesIds = this.selectedCountriesIds || [];

            const min_age = ageRange[0] || null;
            const max_age = ageRange[1] || null;

            const selectedSubcategoryTitles = selectedCategoryIds
                .map(id => {
                    const parentCategory = Object.values(userCategories).find(category =>
                        category.sub_categories?.some(sub => sub.id === id)
                    );
                    return parentCategory?.sub_categories?.find(sub => sub.id === id)?.title || null;
                })
                .filter(Boolean); 
            this.$mixpanel.click('Apply filter', 'Home Screen', {
                sections,
                min_age,
                max_age,
                tags: selectedTagNames,
                genders: activeGenders,
                categories: selectedSubcategoryTitles,
                countries: selectedCountriesIds
            });
        },
        handleResetFilter() {
            this.$mixpanel.click('Reset filter', 'Home Screen');
            localStorage.removeItem("home_filters");
            this.model = {
                sections: ["subscribed", "following", "discover"],
                range: [18, 100],
                panel: "",
                categoriesPanel: "",
                countriesPanel: "",
                tags: [],
                categories: [],
                activeGenders: [],
                countries: [],
            };
            // this.model = {...DEFAULT_FILTERS}`
            this.setFilters(this.model);
            this.$emit("reset", this.model);
        },

        handleSelectedCategories(selectedIds) {
            this.model.categories = selectedIds
        },

        onCountryToggle(countryId) {
            this.$nextTick(() => {
                const allOption = this.countries.find(c => c.name.toLowerCase() === 'all');
                if (!allOption) return;

                const allId = allOption.id;
                const countryIds = this.countries.map(c => c.id).filter(id => id !== allId);
                const isChecked = this.model.countries.includes(countryId);
                if (countryId === allId) {
                    if (isChecked) {
                        this.model.countries = [allId, ...countryIds];
                    } else {
                        this.model.countries = [];
                    }
                    return;
                }
                if (this.model.countries.includes(allId)) {
                    this.model.countries = this.model.countries.filter(id => id !== allId);
                    return;
                }

                if (countryIds.every(id => this.model.countries.includes(id))) {
                    this.model.countries = [allId, ...countryIds];
                }
            });
        },

        ...mapMutations(["setFilters"]),
    },
    components: {  SelectGender, FilterHomeBlock, Dialog, InformDialog, UserCategories, Globe },
    mounted() {
        this.$mixpanel.identifyUser(this.currentUser.email);
        const homeFilters = localStorage.getItem("home_filters");
        if (homeFilters) {
            this.setFilters(JSON.parse(homeFilters));
        }
        this.model = this.filters;
        this.getTags();
    },
};
</script>

<style scoped lang="scss">
.SectionControl {
    &-wrapper {
        // display: flex;
        // justify-content: space-between;
        // flex-wrap: wrap;
    }
}
.tags-text {
    font-size: 0.9em;
    height: 32px;
}
.title-filter {
    font-size: 1.4em;
}

.expand-block-header__before-post.v-expansion-panel-header--active {
    background-color: transparent;
    border-radius: 16px 16px 0 0;
}

.expand-block-header__before-post:not(.v-expansion-panel-header--active) {
    background-color: transparent;
    border-radius: 16px;
    transition: 0.7s;
}

.expand-block-body__before-post {
    background-color: transparent;
    border-radius: 0 0 16px 16px;
}

.theme--dark.v-expansion-panels .v-expansion-panel {
    background-color: transparent;
    color: #f5f4e5;
}

.flags {
  width: 17px;
  height: 13px;
  object-fit: cover;
  border-radius: 2px;
}
.globe-flag {
  width: 18px;
  height: 18px;
  object-fit: cover;
  border-radius: 2px;
}
</style>
